export default [{
    path: 'info',
    component: resolve => require(['../views/enterprise/info.vue'], resolve)
}, {
    path: 'org',
    component: resolve => require(['../views/enterprise/org.vue'], resolve)
}, {
    path: 'account',
    name: 'account',
    component: resolve => require(['../views/enterprise/account.vue'], resolve)
}, {
    path: 'role',
    name: 'role',
    component: resolve => require(['../views/enterprise/role.vue'], resolve)
}]
